import { useSearchParams } from 'react-router-dom'
import moment from 'moment'

// Date range for all /kpi pages, backed by URL search params so it survives
// navigation between the overview and section pages. Defaults to last 30 days.
const useKpiDateRange = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const startParam = searchParams.get('start')
  const endParam = searchParams.get('end')
  const startDate =
    startParam && moment(startParam).isValid()
      ? moment(startParam).startOf('day')
      : moment().subtract(30, 'days').startOf('day')
  const endDate =
    endParam && moment(endParam).isValid()
      ? moment(endParam).endOf('day')
      : moment().endOf('day')

  const onChange = ({ startDate: nextStart, endDate: nextEnd }) => {
    setSearchParams(
      (previous) => {
        const next = new URLSearchParams(previous)
        next.set('start', moment(nextStart).format('YYYY-MM-DD'))
        next.set('end', moment(nextEnd).format('YYYY-MM-DD'))
        return next
      },
      { replace: true },
    )
  }

  return {
    value: { startDate, endDate },
    onChange,
    query: `startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`,
    search: `?start=${startDate.format('YYYY-MM-DD')}&end=${endDate.format('YYYY-MM-DD')}`,
  }
}

export default useKpiDateRange
